import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LocalService } from './services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(private router: Router, @Inject(PLATFORM_ID) private platform: Object) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platform)) {
      this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) return;

        window.scrollTo(0, 0);
      });
    }
  }
}
